"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const strings_1 = require("../../../../../../../constants/strings");
const query_keys_1 = require("../../../../../../../queries/query-keys");
const sessionQuery_1 = require("../../../../../../../queries/sessionQuery");
const userRepository_1 = __importDefault(require("../../../../../../../repositories/userRepository"));
const pageLoader_1 = __importDefault(require("../../../../../../../router/loaders/pageLoader"));
const Root_1 = require("../../../../../../../router/Root");
const userSelectors_1 = require("../../../../../../../selectors/userSelectors");
const zustandStore_1 = require("../../../../../../../zustandStore");
const lexico = new lexico_1.default();
const AllSetMessage = () => {
    const navigate = (0, react_router_1.useNavigate)();
    const { setNotification } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const logout = (0, sessionQuery_1.useSessionLogoutQuery)();
    const handleLogin = async () => {
        const user = await userRepository_1.default.getUser();
        Root_1.queryClient.setQueryData([query_keys_1.userKeys.getUser], user);
        const isTsAdmin = (0, userSelectors_1.isSupportAdmin)(user?.roles);
        if (user && !isTsAdmin && !(0, userSelectors_1.isCompanyOrSupportAdmin)(user?.roles) && user?.roles.length === 0) {
            logout.mutate();
            setNotification([
                {
                    type: strings_1.notificationStrings.ERROR,
                    message: lexico.trc('Error message', 'Your account has been disabled, please contact your company or team administrator.'),
                },
            ]);
        }
        else if (isTsAdmin) {
            void navigate('/overview');
        }
        else {
            if ((0, userSelectors_1.isCompanyOrSupportAdmin)(user?.roles || [])) {
                void navigate('/wallet');
            }
            else {
                void navigate('/wallet/my-cards');
            }
        }
    };
    (0, react_1.useEffect)(() => {
        void handleLogin();
    }, []);
    return (0, jsx_runtime_1.jsx)(pageLoader_1.default, { containerStyle: { width: '100vw' } });
};
exports.default = AllSetMessage;
